export { GenericDialog } from './GenericDialog';
